import { useRef, useState } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Box, Button, CircularProgress, Container, Grid, Paper, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@emotion/react';
import { QrReader } from 'react-qr-reader';
import ReplayIcon from '@mui/icons-material/Replay';
import { ReactComponent as WarningImg } from '../../assets/images/svg/mobile-warning.svg';
import { LectorQRGenerarOrdenDigitalMobile } from './components/LectorQRGenerarOrdenDigitalMobile';
import { validarTokenConsulta } from '../../services/Seo/OrdenDigital';

const SmartQrReader = () => {
  const history = useHistory();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down('md'));
  const [qrNoValido, setQrNoValido] = useState(false);
  const [onCancelar, setOnCancelar] = useState(false);
  const [detecting, setDetecting] = useState(false);
  const detectingRef = useRef(false);

  const handleOnQRResult = async (result) => {
    if (!result) return;
    const rawText = result?.text;
    if (!rawText || detectingRef.current) return;

    detectingRef.current = true;
    setDetecting(true);

    try {
      const tokenData = await validarTokenConsulta(rawText);

      if (tokenData?.codigoPrestador) {
        history.push('/read-orden', { qrToken: rawText, tokenData });
      } else if (tokenData?.numeroOrden) {
        history.push('/read-orden-impresa', { qrToken: rawText, tokenData });
      } else {
        detectingRef.current = false;
        setDetecting(false);
        setQrNoValido(true);
      }
    } catch (e) {
      detectingRef.current = false;
      setDetecting(false);
      setQrNoValido(true);
    }
  };

  if (onCancelar) {
    return <Redirect to={{ pathname: '/', state: { from: '/read-qr' } }} />;
  }

  if (qrNoValido) {
    return (
      <Container component='main' maxWidth='sm'>
        <Paper sx={{ p: 2 }}>
          <Grid container spacing={3}>
            <Grid item>
              <Grid container direction='row' justifyContent='center' alignItems='center'>
                <Grid xs={2} item>
                  <WarningImg />
                </Grid>
                <Grid xs={10} item>
                  <Typography align='center' variant='body2' color='secondary'>
                    Oops! No pudimos escanear correctamente el código QR
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
            <Grid item>
              <Typography variant='body2'>Verificá que tu cámara esté alineada.</Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                Verificá que la cámara de tu dispositivo esté limpia.
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant='body2'>
                Verificá que el reflejo de las luces no genere ruidos en la foto.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Button
                size='small'
                startIcon={<ReplayIcon />}
                variant='contained'
                color='primary'
                fullWidth={true}
                onClick={() => {
                  detectingRef.current = false;
                  setQrNoValido(false);
                }}
              >
                Reintentar
              </Button>
            </Grid>
          </Grid>
        </Paper>
      </Container>
    );
  }

  if (detecting) {
    return (
      <Container component='main' maxWidth='sm'>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', mt: 8, gap: 2 }}>
          <CircularProgress />
          <Typography variant='body2' color='text.secondary'>
            Procesando código QR...
          </Typography>
        </Box>
      </Container>
    );
  }

  if (isMobileScreen) {
    return (
      <LectorQRGenerarOrdenDigitalMobile
        onResult={handleOnQRResult}
        onClose={() => setOnCancelar(true)}
        title='Código QR'
        description='Escaneá el código QR generado en <b>Mi Consultorio</b>.'
      />
    );
  }

  return (
    <Container component='main' maxWidth='sm'>
      <Paper sx={{ p: 2 }}>
        <Typography variant='string' component='div' align='center' sx={{ pb: 3 }}>
          Escaneá el código QR generado en Mi Consultorio
        </Typography>
        <QrReader
          constraints={{ facingMode: 'environment' }}
          onResult={handleOnQRResult}
          style={{ width: '100%' }}
        />
      </Paper>
    </Container>
  );
};

export default SmartQrReader;
